/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import { RouteObject } from 'react-router-dom';
import { LandingPage } from './navigation';

export const getLandingPageRoute = (props: any): RouteObject | any => {
  return {
    path: '/',
    element: <LandingPage navigation={{}} />,
  };
};
